import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AppButton, AppCard } from "@dcam/dcam_flhealth_component_library";
import formsubmit from "../../assets/img/FormSubmitted.png"

const FacilityRegistrationSuccess: React.FC = () => {
  const helpDesk = "1-800-123-4567"; // Example help desk number
  const query = new URLSearchParams(useLocation().search);
  const email = query.get('email'); // Replace with dynamic email retrieval if necessary

  return (
    <div className="mt-20">
    <AppCard>
      <div className="row">
        <div className="col col-md-12 text-center">
          <div className="text-align: center;">
            <img
              className="img-fluid"
              src={formsubmit} // Replace with the actual image path
              alt="Success"
              height="285px"
              width="450px"
            />
           <div style={{ fontSize: "18px", textAlign: "center" }}>
              <b>Facility Registration Form Submitted Successfully!</b>
            </div>
            <br />
            <div style={{ fontSize: "16px", textAlign: "center" }}>
              Your request has been saved. To complete the submission process,
              you must verify your email address.
            </div>
            <br />
            <div style={{ fontSize: "16px", textAlign: "center" }}>
              Once you receive the request, please click the verification link
              sent to the email address - <strong>{email}</strong>. Be sure to
              check your spam folder. The link will expire in{" "}
              <strong>24 hours</strong>.
            </div>
            <br />
            <div style={{ fontSize: "16px", textAlign: "center" }}>
              If you are unable to verify using the link sent to your email
              address, please call the Helpdesk for
              verification.
            </div>
            <div style={{ fontSize: "16px", textAlign: "center" }}>
              You may close the browser now.
            </div>
            <br />
            <NavLink to="/FacilityRegistration">
              <AppButton
                type="button"
                variant="primary"
                text="Add Another Facility"
              />
            </NavLink>
          </div>
        </div>
      </div>
    </AppCard>
    </div>
  );
};

export default FacilityRegistrationSuccess;
